// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./../../../Img/preview__bg.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./../../../Img/preview__mobile.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PreviewBlock_preview__block__WBiDE {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
	background-blend-mode: multiply;
	width: 100vw;
	height: 100vh;

	background-size: cover;

	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-direction: column;

	padding-top: 12rem;
	padding-bottom: 5rem;
}

.PreviewBlock_preview__title__Vp7t5 {
	color: var(--text-color, #fff);
	/* H1 */
	font-family: 'Cormorant';
	font-size: 7.0875rem;
	font-style: normal;
	font-weight: 600;
	line-height: normal;

	margin-bottom: 0.8rem;
	text-align: center;
}

.PreviewBlock_preview__subtitle__HHGrs {
	color: var(--font-color, #fff);
	text-align: center;
	/* text small semibold */
	font-family: 'Noto Sans';
	font-size: 1.4rem;
	font-style: normal;
	font-weight: 600;
	line-height: 160%; /* 1.6rem */

	width: 40%;
}

.PreviewBlock_preview__text__7fCAU {
	display: flex;
	flex-direction: column;
	align-items: center;
}

@media (min-height: 950px) {
	.PreviewBlock_preview__block__WBiDE {
		padding-top: 15rem;
	}
}

@media (max-width: 1440px) {
	.PreviewBlock_preview__subtitle__HHGrs {
		width: 55%;
	}
}

@media (max-width: 1280px) {
	.PreviewBlock_preview__title__Vp7t5 {
		font-size: 6rem;
	}
	.PreviewBlock_preview__subtitle__HHGrs {
		font-size: 1.2rem;

		width: 55%;
	}
}

@media (max-width: 460px) {
	.PreviewBlock_preview__title__Vp7t5 {
		font-size: 3.4375rem;
		font-style: normal;
		font-weight: 600;
		line-height: 100%;
	}
	.PreviewBlock_preview__subtitle__HHGrs {
		font-size: 0.9375rem;
		padding: 0rem 2rem;
		width: 90%;
	}
	.PreviewBlock_preview__block__WBiDE {
		background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
		padding: 10rem 0 0.94rem;
	}
}

@media (max-width: 460px) and (max-height: 750px) {
	.PreviewBlock_preview__block__WBiDE {
		background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
		padding: 8rem 0 0.94rem;
	}
}

@media (max-width: 460px) and (max-height: 690px) {
	.PreviewBlock_preview__block__WBiDE {
		background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
		padding: 6rem 0 0.94rem;
	}
}
`, "",{"version":3,"sources":["webpack://./src/Components/DefaultPage/PreviewBlock/PreviewBlock.module.css"],"names":[],"mappings":"AAAA;CACC,6DAA4D;CAC5D,+BAA+B;CAC/B,YAAY;CACZ,aAAa;;CAEb,sBAAsB;;CAEtB,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,sBAAsB;;CAEtB,kBAAkB;CAClB,oBAAoB;AACrB;;AAEA;CACC,8BAA8B;CAC9B,OAAO;CACP,wBAAwB;CACxB,oBAAoB;CACpB,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;;CAEnB,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,8BAA8B;CAC9B,kBAAkB;CAClB,wBAAwB;CACxB,wBAAwB;CACxB,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;;CAE9B,UAAU;AACX;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC;EACC,kBAAkB;CACnB;AACD;;AAEA;CACC;EACC,UAAU;CACX;AACD;;AAEA;CACC;EACC,eAAe;CAChB;CACA;EACC,iBAAiB;;EAEjB,UAAU;CACX;AACD;;AAEA;CACC;EACC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;CAClB;CACA;EACC,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;CACX;CACA;EACC,yDAA2D;EAC3D,wBAAwB;CACzB;AACD;;AAEA;CACC;EACC,yDAA2D;EAC3D,uBAAuB;CACxB;AACD;;AAEA;CACC;EACC,yDAA2D;EAC3D,uBAAuB;CACxB;AACD","sourcesContent":[".preview__block {\n\tbackground: url('./../../../Img/preview__bg.jpeg') no-repeat;\n\tbackground-blend-mode: multiply;\n\twidth: 100vw;\n\theight: 100vh;\n\n\tbackground-size: cover;\n\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tflex-direction: column;\n\n\tpadding-top: 12rem;\n\tpadding-bottom: 5rem;\n}\n\n.preview__title {\n\tcolor: var(--text-color, #fff);\n\t/* H1 */\n\tfont-family: 'Cormorant';\n\tfont-size: 7.0875rem;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: normal;\n\n\tmargin-bottom: 0.8rem;\n\ttext-align: center;\n}\n\n.preview__subtitle {\n\tcolor: var(--font-color, #fff);\n\ttext-align: center;\n\t/* text small semibold */\n\tfont-family: 'Noto Sans';\n\tfont-size: 1.4rem;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 160%; /* 1.6rem */\n\n\twidth: 40%;\n}\n\n.preview__text {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n}\n\n@media (min-height: 950px) {\n\t.preview__block {\n\t\tpadding-top: 15rem;\n\t}\n}\n\n@media (max-width: 1440px) {\n\t.preview__subtitle {\n\t\twidth: 55%;\n\t}\n}\n\n@media (max-width: 1280px) {\n\t.preview__title {\n\t\tfont-size: 6rem;\n\t}\n\t.preview__subtitle {\n\t\tfont-size: 1.2rem;\n\n\t\twidth: 55%;\n\t}\n}\n\n@media (max-width: 460px) {\n\t.preview__title {\n\t\tfont-size: 3.4375rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 100%;\n\t}\n\t.preview__subtitle {\n\t\tfont-size: 0.9375rem;\n\t\tpadding: 0rem 2rem;\n\t\twidth: 90%;\n\t}\n\t.preview__block {\n\t\tbackground-image: url('./../../../Img/preview__mobile.png');\n\t\tpadding: 10rem 0 0.94rem;\n\t}\n}\n\n@media (max-width: 460px) and (max-height: 750px) {\n\t.preview__block {\n\t\tbackground-image: url('./../../../Img/preview__mobile.png');\n\t\tpadding: 8rem 0 0.94rem;\n\t}\n}\n\n@media (max-width: 460px) and (max-height: 690px) {\n\t.preview__block {\n\t\tbackground-image: url('./../../../Img/preview__mobile.png');\n\t\tpadding: 6rem 0 0.94rem;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"preview__block": `PreviewBlock_preview__block__WBiDE`,
	"preview__title": `PreviewBlock_preview__title__Vp7t5`,
	"preview__subtitle": `PreviewBlock_preview__subtitle__HHGrs`,
	"preview__text": `PreviewBlock_preview__text__7fCAU`
};
export default ___CSS_LOADER_EXPORT___;
